<template>
    <div>
        <!-- 内容 -->
        <div class="main-content">
            <div class="main-body">
                <div class="selection">
                    <Banner :bannerData="bannerData" class="banner"></Banner>
                    <!-- 内容 -->
                    <div class="content-box">
                        <!-- 基金会项目 -->
                        <div>
                            <div class="content-container-top">
                                <div class="content-box-top">
                                    <div class="top-lf">{{ $t('FoundationProject') }}</div>
                                    <div class="top-more" @click="$router.push('/foundationProject')">{{$t('ViewDetails')}}</div>
                                </div>
                            </div>
                            <div class="content-box-center">
                                <div class="content-container"
                                    @click="toJump(item.id)"
                                    v-for="item in foundationProjectList.filter((listItem, i) => i >= 4 * page && i < 3 * (page + 1))"
                                    :key="item.id">
                                    <img :src="item.imgUrl" alt="">
                                    <div class="content-container-title">
                                        <div class="content-container-txt">{{ item.name }}</div>
                                        <div class="content-center">
                                            <div>{{ item.content }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <!-- 专项基金 -->
                        <div>
                            <div class="content-container-top special">
                                <div class="content-box-top">
                                    <div class="top-lf">{{ $t('SpecialFund') }}</div>
                                    <div class="top-more" @click="$router.push('/specialFund')">{{$t('ViewDetails')}}</div>
                                </div>
                            </div>
                            <!-- <div class="special-box">
                                <div class="list">
                                    <div class="item" v-for="item in specialFundList.filter((listItem, i) => i >= 4*page && i<4*(page+1))" :key="item.id">
                                        <div style="width:100%;" @click="toDetails(item.id)">
                                            <img :src="item.imgUrl" alt="" class="special-fund-card-img">
                                        </div>
                                        <div class="special-fund-card-text">
                                            <div class="home-special-fund-title">{{ item.name }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="swiper-list-box">
                                <div class="swiper-list-content">
                                    <swiper class="swiper-ls" :options="swiperOptions" ref="mySwiper">
                                        <swiper-slide v-for="(item,index) in specialFundList" :key="index" >
                                            <!-- 幻灯片内容 -->
                                            <img :src="item.imgUrl" alt="" style="width:100%;height:100%;" @click="toDetails(item.id,item.status)">
                                            <div class="swiper-box">
                                            <div class="swiper-box-title">{{ item.name }}</div>
                                            <div class="swiper-box-content" style="line-height: 2;">{{ item.content }}</div>
                                            </div>
                                        </swiper-slide>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                        <!-- 相关新闻 -->
                        <div>
                            <div class="content-container-top news">
                                <div class="content-box-top">
                                    <div class="top-lf">{{ $t('CorrelationNews') }}</div>
                                    <div class="top-more" @click="$router.push('/news')">{{$t('ViewDetails')}}</div>
                                </div>
                            </div>
                            <div class="news-box">
                                <div class="news-list-box">
                                    <div @click="goArticleDetail(newsList[0])">
                                        <div class="news-img">
                                            <img v-if="newsList.length > 0" :src="newsList[0].imgUrl" alt="">
                                        </div>
                                        <div v-if="newsList.length > 0" class="news-list">
                                            <div class="news-list-title">{{ newsList[0].title }}</div>
                                            <div class="news-date">
                                                <span class="news-date-month">{{ newsList[0].createDate.split(' ')[0].split('-')[1] + '-' + newsList[0].createDate.split(' ')[0].split('-')[2] }}</span>
                                                <span class="news-line">/</span>
                                                <span class="news-date-year">{{ newsList[0].createDate.split(' ')[0].split('-')[0] }}</span>
                                            </div>
                                            <div class="news-list-digest text-max-2">{{ newsList[0].digest }}</div>
                                        </div>
                                    </div>
                                    <div class="news-list" v-for="item in newsList.filter((items,i)=>i > 0 && i < 6)" :key="item.id" @click="goArticleDetail(item)">
                                        <div class="news-list-line"></div>
                                        <div class="news-date">
                                            <span class="news-date-month">{{ item.createDate.split(' ')[0].split('-')[1] + '-' + item.createDate.split(' ')[0].split('-')[2] }}</span>
                                            <span class="news-line">/</span>
                                            <span class="news-date-year">{{ item.createDate.split(' ')[0].split('-')[0] }}</span>
                                        </div>
                                        <div class="news-list-digest news-list-content-title">{{ item.title }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 关于about -->
                        <div class="about-box">
                            <div class="about-bg" style="min-height: 341px;">
                                <div class="about-title">
                                    <div>{{ aboutFoundation.title }}</div>
                                </div>
                                <div class="about-content">
                                    <div v-html="aboutFoundation.digest" style="min-height: 160px;max-width: 200px;"></div>
                                    <div class="about-btn" @click="()=>{$router.push('/organizationalProfile/foundationIntroduction')}">{{ $t('View') }}<i class="el-icon-arrow-right about-arrow"></i></div>
                                </div>
                            </div>
                        </div>

                        <!-- 基金会创始 -->
                        <div class="fund-box">
                            <div class="fund-title fund-about">
                                <div>{{ $t('FoundingSupportingInstitutionsFoundation') }}</div>
                            </div>
                            <div class="fund-list">
                                <div class="fund-list-item" v-for="item in institutionLogoData" :key="item">
                                    <img :src="item" alt="" width="100%" class="img-shadow">
                                </div>
                            </div>
                        </div>

                        <!-- 理事单位 -->
                        <div class="unit-box">
                            <div class="unit-title">{{ $t('CouncilMembers') }}</div>
                            <div class="unit-list">
                                <div class="unit-list-item" v-for="item in councilImgs" :key="item">
                                    <img :src="item" alt="" width="100%" class="img-shadow">
                                </div>
                            </div>
                        </div>

                        <!-- top -->
                        <div class="top-btn-box">
                            <div @click="goTop">
                                <img src="../../assets/img/to-top.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { pageArticleByModuleId, listBannerByModuleId, listInfo, listSpecFund } from '@/api/index'
export default {
    data() {
        return {
            isShowAD:false,
            aboutFoundation:{},
            bannerData: [],
            foundationProjectList: [],
            specialFundList: [],
            // 基金会创始
            institutionLogoData: [],
            // 理事单位
            councilImgs: [],
            newsList: [],
            drawer: false,
            zuzhi:false,
            page: 0,
            swiperOptions:{
                // 启用模块
                autoplay: {
                delay: 3000,
                disableOnInteraction: false
                },
                loop: true,  // 添加循环滚动
                slidesPerView: 1,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    hideOnClick: false
                },
                // 动态更新处理
                observer: true,
                observeParents: true
            },
        }
    },
    created() {
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'referrer');
        meta.setAttribute('content', 'never');
        document.head.appendChild(meta);
        // 触底后会有一个 homeToBottom 发送过来
        this.$bus.$on('homeToBottom', this.getNewDate)
        // 导航分类变化时，homeCateChange 会发送过来
        this.$bus.$on('homeCateChange', (cate_id) => {
            // console.log('我的分类子列表', list, cate_id)
            document.documentElement.scrollTop = 0

            this.$message.success(
                `分类ID：${cate_id},接口没有分类参数，这里走传参流程`
            )
        })
        // 页面刷新时读取点击状态
        this.checked = window.sessionStorage.getItem('checked') || '推荐'
        this.value = window.sessionStorage.getItem('value') || ''
        this.showSelector = this.checked === '热榜' ? true : false
        // this.params.sort_type = window.sessionStorage.getItem('sort_type ') || 200
        this.getData()
        this.getAboutFoundation()
        // 关于萨玛
        this.listFoundingSupportingInstitutionsOfTheFoundation()
        // 理事单位
        this.listCouncil()
    },
    methods: {
        
        async getData() {
            // 相关新闻
            this.newsList = (await this.pageArticleByModuleIds()).records
            let foundationProjectList = (await this.listSpecFunds(1)).records
            // 基金会
            this.foundationProjectList = foundationProjectList.length > 8 ? foundationProjectList.slice(0, 8) : foundationProjectList
            // 专项基金
            this.specialFundList = (await this.listSpecFunds(2)).records
            // 相关新闻
            this.foundationIntroductionList = (await this.pageArticleByModuleIds(9, 1, 1)).records
            // banner图
            this.listBannerByModuleIds()
        },
        async listSpecFunds(moduleId) {
            let res = await listSpecFund({
                "type": moduleId,
                "page": 1,
                "size": 9
            })
            if (res.data && res.data != null) {
                return res.data
            } else {
                return ''
            }
        },
        // 基金会项目跳转
        toJump(id) {
            this.$router.push({
                path: "/foundationProject/sectorList",
                query: {
                id: id,
                },
            });
        },
        // 专项基金跳转
        toDetails(id,status) {
			if(status == 0){
				const routeUrl = this.$router.resolve({
				    path: '/specialFundDetails',
				    query: {
				    id: id
				    }
				})
				window.open(routeUrl.href, "_blank")
			}
        },
        // 相关新闻跳转
        goArticleDetail(news) {
            this.$router.push({
                path: '/newsDetails',
                query: {
                id: news.id,
				fundId:1
                },
            });
        },
        // banner图
        listBannerByModuleIds() {
            const formData = new FormData();

            // 添加字符串类型的数据
            formData.append("moduleId", 1);
            listBannerByModuleId(formData).then(res => {
                if (res.data && res.data != null) {
                    this.bannerData = res.data
                }

            })
        },
        // 相关新闻
        async pageArticleByModuleIds(moduleId, page, size, title) {
            let res = await pageArticleByModuleId({
                "moduleId": moduleId || 1,
                "page": page || 1,
                "size": size || 10,
                "title": title || ""
            })
            if (res.data && res.data != null) {
                return res.data
            } else {
                return ''
            }
        },
        //关于基金会
        getAboutFoundation() {
            const formData = new FormData();
            formData.append("moduleId", 17);
            listInfo(formData).then(res => {
                if (res.data && res.data != null) {
                this.aboutFoundation = res.data[0];
                }
            })
        },
        //获取基金会创始支持机构
        listFoundingSupportingInstitutionsOfTheFoundation() {
            const formData = new FormData();
            formData.append("moduleId", 18);
            listInfo(formData).then(res => {
                if (res.data && res.data != null) {
                    for (var i = 0; i < res.data.length; i++) {
                        this.institutionLogoData.push(res.data[i].imgUrl);
                    }
                }
            })
        },
        //理事单位
        listCouncil() {
            const formData = new FormData();
            formData.append("moduleId", 19);
            listInfo(formData).then(res => {
                if (res.data && res.data != null) {
                    for (var i = 0; i < res.data.length; i++) {
                        this.councilImgs.push(res.data[i].imgUrl);
                    }
                }
            })
        },
        goTop(){
            document.documentElement.scrollTop = 0
        },
        
        zuzhiClick() {
            this.zuzhi = !this.zuzhi;
        }
    }
}

</script>

<style lang="less" scoped>
/deep/.el-carousel__item img {
    object-fit: cover;
}

/deep/.el-carousel__container {
    height: 143px !important;
}

.swiper-list-box{
  width: 100%;
  position: relative;
  .swiper-list-content{
    padding: 2rem 5%;
    position: relative;
    .swiper-ls{
      overflow: hidden;
    }
  }
  // 添加以下样式
  &:hover {
    .swiper-button-prev,
    .swiper-button-next {
      // opacity: 1;
    }
  }
  
  .swiper-button-prev,
  .swiper-button-next {
    // opacity: 0;
    // transition: opacity 0.3s;
    
    &:after {
      font-size: 1.5rem;
      color: #aa221d;
    }
  }

  
  // background: #fff;
}
.swiper-box{
  background: #f8f8f8;
  padding: 1.5rem 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  height: 16.2rem;
  .swiper-box-title {
    font-weight: 1000;
    font-size: 1.3rem;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 隐藏超出的内容 */
    text-overflow: ellipsis;
  }
  .swiper-box-content{
    font-size: 1.1rem;
    display: -webkit-box;
    -webkit-line-clamp: 7; /* 显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
    margin-top: 0.5rem;
    line-height: 2.0rem;
  }
}


.footer{
    .footer-center{
        background: #B8210F;
        .footer-top{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            padding: 14px 0 24px;
            .footer-line{
                width: 1px;
                height: 8px;
                background: #fff;
                margin: 0 16px;
           }
        }
        .social {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 6px;
            .social-item{
                flex: 0 0 calc((100% - 100px)/2);
                margin: 0 0 12px 0;
                .social-item-content{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    img {
                        width: 23px;
                        height: 23px;
                    }
                }
                
            }
            .social-item:nth-child(2n) {
                /* 去除第3n个的margin-right */
                margin-right: 0;
            }
        }
    }
    .footer-bottom{
        padding: 6px;
        background: #231F20;
        color: #D3D3D3;
        font-size: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.main-content {
    padding: 0 0 0 0;

    .main-body {
        color: #262a33;
        .selection{
            background: #fff;
            .content-box {
                .content-container-top {
                    padding: 0 18px;
                    background: #fff;

                    .content-box-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 44px 0 25px;
                        padding-right: 0;
                        padding-left: 0;
                        // margin: 0 18px;

                        .top-lf {
                            font-size: 22px;
                            font-weight: 800;
                        }

                        .top-more {
                            width: 70px;
                            height: 24px;
                            font-size: 11px;
                            color: #fff;
                            background: #BA000E;
                            border-radius: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }

                .content-box-center {
                    .content-container:first-child {
                        margin-top: 0px !important;
                    }

                    .content-container {
                        padding: 0 18px;
                        margin-top: 14px;
                        
                        img {
                            width: 100%;
                        }

                        .content-container-title {
                            background: #f8f8f8;
                            padding: 0 10px;
                            border-bottom-left-radius: 8px;
                            border-bottom-right-radius: 8px;

                            .content-container-txt {
                                font-size: 15px;
                                font-weight: 800;
                                padding-top: 15px;
                            }

                            .content-center {
                                font-size: 13px;
                                padding: 5px 0 22px;

                                div {
                                    height: 44px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    /* 限制显示的行数为2 */
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    line-height: 22px;
                                }
                            }
                        }
                    }
                }

                .special {
                    margin-top: 44px;
                }

                .special-box {
                    .list {
                        display: flex;
                        overflow: auto;
                        background: #fff;
                        margin: 0 18px;
                    }
                    .item:first-child{
                        margin-left: 0;
                    }
                    .item {
                        border-radius: 8px;
                        flex-shrink: 0;
                        margin-left: 10px;
                        .special-fund-card-img {
                            object-fit: cover;
                            width: 246px;
                            height: 331px;
                            border-radius: 5px;
                        }
                        .special-fund-card-text {
                            position: relative;
                            .home-special-fund-title {
                                font-size: 15px;
                                font-weight: 600;
                                color: rgb(255, 255, 255);
                                width: 100%;
                                box-sizing: border-box;
                                text-align: center;
                                position: absolute;
                                bottom: 25px;
                                text-shadow: -0.05rem -0.05rem #757373, 0.05rem 0.05rem #757373;
                                padding: 0 1rem;
                                white-space: nowrap; /* 禁止文字换行 */
                                overflow: hidden; /* 隐藏超出容器宽度的部分 */
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }
                // .news {
                //     margin-top: 44px;
                // }
                .news-box {
                    padding: 0 18px 50px 18px;
                    background: #fff;
                    .news-list-box{
                        .news-img {
                            img {
                                width: 100%;
                                height: 204px;
                                object-fit: cover;
                                border-radius: 5px;
                            }
                        }
                        .news-list {
                            .news-list-title{
                                white-space: nowrap; /* 禁止文字换行 */
                                overflow: hidden; /* 隐藏超出容器宽度的部分 */
                                text-overflow: ellipsis;
                                padding: 15px 0 5px;
                                font-size: 15px;
                                font-weight: 600;
                            }
                            .news-date {
                                display: flex;
                                align-items: center;
                                .news-date-month {
                                    font-size: 13px;
                                    font-weight: 600;
                                }
                                .news-line {
                                    color: #777777;
                                    padding: 0 2px 0 5px;
                                }
                                .news-date-year {
                                    font-size: 10px;
                                    color: #777777;
                                }
                            }
                            .news-list-digest {
                                margin-top: 8px;
                                font-size: 13px;
                                line-height: 22px;
                                color: #5B5B5B;
                            }
                            .news-list-content-title{
                                width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                color: #000000;
                            }

                            .news-list-line{
                                height: 1px;
                                width: 100%;
                                margin: 15px 0;
                                background-color: #dcdfe6;
                            }
                        }
                        .news-list-item {
                            border-radius: 8px;
                            flex-shrink: 0;
                            margin-left: 10px;
                        }
                    }
                
                }

                .about-box{
                    width: 100%;
                    box-sizing: border-box;
                    // background-color: rgb(184, 33, 15);
                    overflow: hidden;
                    .about-bg {
                        width: 100%;
                        // height: 360px;
                        padding: 44px 0;
                        box-sizing: border-box;
                        // background-position: right -20px bottom;
                        // background-size: 65%;
                        // background-size: 277px 228px;
                        background-repeat: no-repeat;
                        background-image: url(../../assets/img/bg_jj.jpg);
                        background-size: 100%;
                    }
                    .about-title {
                        width: 100%;
                        color: #fff;
                        font-size: 21px;
                        margin: 0 0 12px 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        div {
                            width: 330px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                    .about-content {
                        width: 230px;
                        color: #fff;
                        font-size: 10px;
                        padding: 0 30px;
                        padding-bottom: 13px;
                        line-height: 24px;
                        .about-btn {
                            width: 81px;
                            height: 24px;
                            background: #FDFEFF;
                            border-radius: 12px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 11px;
                            color: #333333;
                            .about-arrow{
                                margin-left: 8px;
                            }
                        }
                    } 
                }

                .fund-box{
                    background: #fff;
                    .fund-about{
                        width: 100%;
                        div {
                            width: 330px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: center;
                        }
                    }
                    .fund-title {
                        padding: 55px 0 28px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 21px;
                        font-weight: 600;
                    }
                    .fund-list{
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0 32px 0 37px;
                        .fund-list-item {
                            flex: 0 0 calc((100% - 10px)/3);
                            /* 间隙为5px */
                            margin: 0 5px 5px 0;
                            img {
                                box-shadow: 0 0 2px #f0eeee;
                            }
                        }
                        .fund-list-item:nth-child(3n) {
                            /* 去除第3n个的margin-right */
                            margin-right: 0;
                        }
                    }
                }

                .unit-box{
                    background: #fff;
                    .unit-title {
                        padding: 55px 0 28px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 21px;
                        font-weight: 600;
                    }
                    .unit-list{
                        display: flex;
                        flex-wrap: wrap;
                        padding: 0 32px 0 37px;
                        .unit-list-item {
                            flex: 0 0 calc((100% - 16px)/3);
                            /* 间隙为5px */
                            margin: 0 8px 8px 0;
                            img {
                                box-shadow: 0 0 2px #f0eeee;
                            }
                        }
                        .unit-list-item:nth-child(3n) {
                            /* 去除第3n个的margin-right */
                            margin-right: 0;
                        }
                    }
                }

                .top-btn-box{
                    width: 100%;
                    box-sizing: border-box;
                    padding: 43px 13px 20px 0;
                    display: flex;
                    align-items: center;
                    justify-content: right;
                    background-color: rgb(255, 255, 255);
                    img{
                        width: 32px;
                        height: 32px;
                        cursor: pointer;
                        border: none !important;
                    }
                }
            }
        }
        
    }
}
</style>